import Image, { type StaticImageData } from 'next/image';

import StepsFirstImage from '@/assets/CNC-rfq/steps-first.png';
import StepsSecondImage from '@/assets/CNC-rfq/steps-second.png';
import StepsThirdImage from '@/assets/CNC-rfq/steps-third.png';
import Button from '@/components/Button';
import Text from '@/components/Text';
import { smoothScroll } from '@/utils/smoothScroll';

const steps: {
  number: number;
  image: StaticImageData;
  title: string;
  description: string;
}[] = [
  {
    number: 1,
    image: StepsFirstImage,
    title: 'Upload CAD or drawing',
    description:
      'Drop 3D models (STEP, STP) or 2D drawings (DXF, PDF) straight into the engine. No setup.',
  },
  {
    number: 2,
    image: StepsSecondImage,
    title: 'Configure instantly',
    description:
      'Set material, finish and quantity. Unit price, tiered discounts and lead time recalculate live.',
  },
  {
    number: 3,
    image: StepsThirdImage,
    title: 'Quote & reorder',
    description:
      'Export a clean, client-ready PDF and reorder any past part in a single click.',
  },
];

const CncRfqHowItWorks = () => {
  return (
    <div className="flex w-full flex-col items-center gap-11">
      <div className="flex flex-col items-center gap-5 text-center">
        <Text
          variant="display-4"
          className="max-w-3xl text-center text-jb-neutral-900"
        >
          From CAD file to detailed quote in 3 easy steps
        </Text>
        <Text className="!text-md max-w-[511px] text-center text-jb-neutral-800 md:!text-lg lg:!text-xl">
          Skip the emails and the back-and-forth. Turn your part files into
          actionable quotes in under 30 seconds.
        </Text>
        <Button
          variant="jbPrimary"
          className="text-[19px] text-neutral-0"
          iconClassName="text-[24px]"
          prefixIcon="material-symbols:play-circle-rounded"
          onClick={() => smoothScroll('#cnc-rfq-upload')}
        >
          See how it works
        </Button>
      </div>
      <div className="grid w-full grid-cols-1 gap-6 lg:grid-cols-3">
        {steps.map(({ number, image, title, description }) => (
          <div
            key={number}
            className="flex flex-1 flex-col gap-5 rounded-[20px] border border-jb-neutral-300 bg-jb-neutral-100 p-7 shadow-md backdrop:blur-sm"
          >
            <div className="w-full overflow-hidden rounded-xl">
              <Image src={image} alt="" className="h-auto w-full" />
            </div>
            <div className="flex flex-col gap-3">
              <div className="flex items-center gap-3">
                <div className="flex h-[50px] w-[50px] shrink-0 items-center justify-center rounded-full bg-jb-primary-500">
                  <Text className="text-jb-primary-100" variant="h4">
                    {number}
                  </Text>
                </div>
                <Text
                  variant="h4"
                  className="font-semibold text-jb-neutral-900"
                >
                  {title}
                </Text>
              </div>
              <Text className="text-jb-neutral-800">{description}</Text>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CncRfqHowItWorks;
